module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/first.js
// module id = 87
// module chunks = 2